type Capabilities = Record<string, boolean>;

const TABLEOPS_CAPABILITIES = new Set([
  'canAdminTableOps',
  'canViewTableOps',
  'canViewRegister',
  'canViewOrders',
  'canViewProducts',
  'canViewSales',
  'canViewShift',
  'canOpenSession',
  'canCloseSession',
  'canPlaceOrder',
  'canPrepareOrder',
  'canReadyOrder',
  'canServeOrder',
  'canRegisterPayment',
  'canOpenShift',
  'canCloseShift',
]);

const IGNORED_CAPABILITIES = new Set([
  'isSuperadmin',
  'isTableOpsOperator',
  'isPublicVisitor',
  'isTableOpsReadOnly',
  'isTtlockReadOnly',
  'isWorkflowReadOnly',
  'isIamReadOnly',
  'isSystemReadOnly',
]);

/**
 * True when capabilities grant access exclusively to TableOps domain.
 * Read-only marker flags do not count as grants.
 */
export function isTableOpsOnlyCapabilities(capabilities: Capabilities | null | undefined): boolean {
  if (!capabilities || typeof capabilities !== 'object') return false;
  if (capabilities.isTableOpsOperator === true) return true;
  if (capabilities.isSuperadmin === true) return false;

  const enabled = Object.keys(capabilities).filter((key) => capabilities[key] === true);
  const grants = enabled.filter((key) => !IGNORED_CAPABILITIES.has(key));
  if (grants.length === 0) return false;

  return grants.every((key) => TABLEOPS_CAPABILITIES.has(key));
}
